export default (el, { expression }, { evaluate, cleanup }) => {
  const withText = evaluate(expression);

  const disableWithText = () => {
    const tag = el.tagName.toLowerCase();

    if (tag === 'button') {
      el.innerHTML = withText;
    } else {
      el.value = withText;
    }

    setTimeout(() => {
      el.disabled = true;
    });
  };

  el.form.addEventListener('submit', disableWithText);
  cleanup(() => el.form.removeEventListener('submit', disableWithText));
};
